import React, { useContext, useState, useEffect, useRef } from 'react';
import "../styles/SearchCategories.css";
import SearchBar from './SearchBar';
import { AuthContext } from '../contexts/AuthContext';

const SearchZipCode = ({ setShowSearchBar, showCounty}) => {
    
    const { zipCode, updateZipCode } = useContext(AuthContext); // Access zipCode and updateZipCode from AuthContext
    const { countyName, updateCountyName } = useContext(AuthContext); // Access countyName and updateCountyName from AuthContext
    const [locationQuery, setLocationQuery] = useState(zipCode || ''); // Initialize with persisted zip code
    const [isSearched, setIsSearched] = useState(!!zipCode); // Set based on whether a zip code exists
    const [isZipCodeRequired, setIsZipCodeRequired] = useState(false);
    const [zipCodeError, setZipCodeError] = useState(false); // New state for zip code error
    const [highlightZipCodeInput, setHighlightZipCodeInput] = useState(false); // New state to highlight input
    const [isBlinking, setIsBlinking] = useState(false); // State to track the blinking status

    // Create a ref for the zip code input field
    // useRef is a React Hook that lets you reference a value that’s not needed for rendering.
    // Example: const ref = useRef(initialValue)
    const zipCodeInputRef = useRef(null);

    // Focus the zip code input field when the component mounts
    useEffect(() => {
        if (zipCodeInputRef.current) {
            zipCodeInputRef.current.focus();
        }
    }, []);

    //If the user inputs nothihg or blank spaces, tells user that numbers are required.
    //If the user inputs letters and special characters, tells user they need to input numbers.
    //If user input is right, sets location Query to user input.
    const handleZipCodeSearch = (e) => {

        e.preventDefault();

        if (locationQuery.trim() === '') {

            setIsZipCodeRequired(true);
            setZipCodeError(false); // Reset error state if empty
        } else if (!/^\d+$/.test(locationQuery)) {

            setZipCodeError(true); // Set error if non-numeric characters are present
            setIsZipCodeRequired(false); // Reset required state
        } else {

            setIsSearched(true);
            setIsZipCodeRequired(false);
            setZipCodeError(false); // Reset error state on valid input
            updateZipCode(locationQuery); // Persist the zip code in context and localStorage
            
            updateCountyName(''); //Persist the county name in context and localStorage.
            //setShowSearchBar(true); //Makes the services search bar appear
            //setZipCodePage(locationQuery); //Saves the zip code for passing it to the menu. 
        }
    };

    //when the user removes the zip code, all elements are set to initial states.
    const handleRemoveFilter = () => {

        setIsSearched(false);
        setLocationQuery('');
        setIsZipCodeRequired(false);
        setZipCodeError(false); // Reset error state
        updateZipCode(''); // Clear the zip code from context and localStorage
        
        setShowSearchBar(false); //makes the services search bar dissappear.
    };

    //real time checks if user is typing in zip code search box, and changes location query.
    const handleInputChange = (e) => {

        setLocationQuery(e.target.value);

        // Reset the red border and required notice if the user starts entering the zip code
        if (e.target.value !== '') {
            setIsZipCodeRequired(false);
            setIsBlinking(false); // Stops keeping the solid red border
        }

        
    };

    return (

        //zip code search box
        <div className="search-container" style={showCounty ? {pointerEvents: "none", opacity: "0.4"} : {}}>

            {/* when search button is clicked */}
            <form onSubmit={handleZipCodeSearch}>

                {/* <h2 className="search-title">Enter your zip code to get started </h2> */}
                <div className={`search-categories-bar-container ${highlightZipCodeInput ? 'highlight' : (isBlinking ? 'still' : '')}`}>

                    {/* if a proper zip code as been entered, turns searhc box into a filter box
                    If not, gives a message. */}
                    {/* {(isSearched && !showCounty) ? ( */}
                    {(isSearched && !showCounty && zipCode != '') ? (
                        
                        <div className="filter-box">

                            <div className="zipCode">

                                <span>Zip Code: {locationQuery}</span>
                                <button type="button" onClick={handleRemoveFilter}>×</button>
                            </div>

                            {setShowSearchBar(true)}
                        </div>
                        
                    ) : (

                        <div className={`zip-code-input-container ${highlightZipCodeInput ? 'highlight' : (isBlinking ? 'still' : '')}`}>
                            
                            <SearchBar
                                ref={zipCodeInputRef} // Attach ref to the input
                                placeholder="Enter Zip Code"
                                value={locationQuery}
                                onChange={handleInputChange}
                            />
                            {isZipCodeRequired && (
                                <span className="required-notice">Required*</span>
                            )}
                            {zipCodeError && (
                                <span className="required-notice">Please enter numbers only*</span>
                            )}
                            {/* {(zipCodeError || isZipCodeRequired) && (
                                setShowSearchBar(true)
                            )} */}
                        </div>
                    )}
                </div>
            </form>
        </div>
    )
};

export default SearchZipCode;